"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var react_1 = __importDefault(require("react"));

var Button_1 = __importStar(require("../../../Button"));

var Icon_1 = __importStar(require("../../../Icon"));

var index_1 = __importDefault(require("../index"));

var ValuesFilterItem =
/** @class */
function (_super) {
  __extends(ValuesFilterItem, _super);

  function ValuesFilterItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.selectedNames = function () {
      var selected = _this.props.selected;
      var selectedNames = [];

      _this.values.forEach(function (item) {
        var key = lodash_1.toString(item.id);
        var choosen = lodash_1.castArray(selected).indexOf(key) >= 0;

        if (choosen) {
          selectedNames.push(item.name);
        }
      });

      return selectedNames;
    };

    _this.renderSelect = function () {
      return null;
    };

    _this.renderRows = function () {
      return [];
    };

    _this.renderLabel = function () {
      var localization = _this.props.localization;
      var label = _this.props.label || _this.props.id;

      var selectedNames = _this.selectedNames();

      var text;

      if (selectedNames.length === Object.keys(_this.values).length) {
        text = localization.all;
      } else if (selectedNames.length === 0) {
        text = localization.empty;
      } else {
        text = selectedNames.join(', ');
      }

      return react_1.default.createElement("div", null, react_1.default.createElement("label", null, label), react_1.default.createElement("div", {
        className: "fake_input fake_input--withIcon",
        onClick: _this.openDialog
      }, text, react_1.default.createElement(Icon_1.default, {
        icon: Icon_1.IconType.ArrowBottom,
        width: 24,
        height: 24
      })));
    };

    _this.renderDropdownBody = function () {
      var localization = _this.props.localization;

      var rows = _this.renderRows();

      var select = _this.renderSelect();

      return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("input", {
        type: "text",
        placeholder: localization.search,
        onChange: _this.selectFilter
      }), react_1.default.createElement("hr", null), react_1.default.createElement("div", {
        className: "inputs"
      }, select, rows), react_1.default.createElement("hr", null), react_1.default.createElement("div", {
        className: "buttons"
      }, react_1.default.createElement(Button_1.default, {
        variant: Button_1.ButtonVariant.Primary,
        onClick: _this.changeFilters
      }, localization.confirm)));
    };

    return _this;
  }

  Object.defineProperty(ValuesFilterItem.prototype, "values", {
    get: function get() {
      return this.props.values || [];
    },
    enumerable: true,
    configurable: true
  });
  return ValuesFilterItem;
}(index_1.default);

exports.default = ValuesFilterItem;